__turbopack_context__.v({
  "className": "geistmono_b9f59162-module__Or8qSa__className",
  "variable": "geistmono_b9f59162-module__Or8qSa__variable",
});
